import MyAccountRouter from "./MyAccount.router";

export default MyAccountRouter;
